import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'navigation-shortcuts.main.select-item-type-modal.header',
		defaultMessage: 'Add an item to this project',
		description: '',
	},
	headerShortcuts: {
		id: 'navigation-shortcuts.main.select-item-type-modal.header-shortcuts',
		defaultMessage: 'Add shortcut',
		description:
			'The heading of the modal for adding shortcuts - previously this was "Add an item to this project" but has been changed to add shortcut to avoid confusion with other functionality we are adding for customising adding views to projects',
	},
	close: {
		id: 'navigation-shortcuts.main.select-item-type-modal.close',
		defaultMessage: 'Close',
		description: '',
	},
	cancel: {
		id: 'navigation-shortcuts.main.select-item-type-modal.cancel',
		defaultMessage: 'Cancel',
		description: '',
	},
});
